import React from 'react';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import WhatIOffer from './components/WhatIOffer';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navigation />
      <HeroSection />
      <WhatIOffer />
      <AboutSection />
      <ServicesSection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default App;